import firebase from '../../lib/firebase.prod';

export async function setUserPassword(userId, password) {
	let setUserPassword = firebase
		.functions()
		.httpsCallable('resetUserPassword');
	if (userId && password) {
		let result = await setUserPassword({
			id: userId,
			password: password,
		});
		return result;
	}
	return { success: false };
}
